import { useEffect, useState, RefObject } from 'react';

/**
 * Custom hook for managing scroll detection and scroll arrow visibility
 */
export const useScrollDetection = (
    containerRef: RefObject<HTMLElement>,
    content?: string | null
) => {
    const [showScrollArrow, setShowScrollArrow] = useState(false);

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const checkOverflow = () => {
            const isScrollable = container.scrollHeight > container.clientHeight;
            const isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight;
            setShowScrollArrow(isScrollable && !isAtBottom);
        };

        const timeoutId = setTimeout(checkOverflow, 0);

        // Add scroll listener
        container.addEventListener('scroll', checkOverflow);

        // Cleanup
        return () => {
            clearTimeout(timeoutId);
            container.removeEventListener('scroll', checkOverflow);
        };
    }, [containerRef, content]);

    const scrollDown = () => {
        containerRef.current?.scrollBy({ top: 200, behavior: 'smooth' });
    };

    return { showScrollArrow, scrollDown };
};
